import { useQuery, UseQueryOptions } from 'react-query'
import { getClientId } from 'utils/getClientId'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'

export namespace FetchPetBreeds {
  export type Response = { name: string }[]
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = () => ['pet-breed']

const queryFetcher = () => () => {
  return ApiClient.get<FetchPetBreeds.Response>(`/v1/pets/breeds`)
}

export const useFetchPetBreeds = (options?: FetchPetBreeds.Options) => {
  const ownerId = getClientId() || ''
  return useQuery<FetchPetBreeds.Response, FetchPetBreeds.Error>(
    createKey(),
    queryFetcher(),
    options
  )
}
